import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SelectField } from '@segment/react-forms'

const filters = [
  'Added',
  'Credentials Changed',
  'Disabled',
  'Deleted',
  'Enabled',
  'Run Failed',
  'Success'
]

const options = filters.map(filter => ({
  label: filter,
  value: filter
}))

options.unshift({
  value: '',
  label: 'All Activities'
})

class ActivityFilter extends Component {
  render () {
    return (
      <div className='ActivityFilter'>
        <SelectField
          defaultValue={this.props.selectedFilter}
          onChange={this.handleOnChange.bind(this)}
          options={options} />
      </div>
    )
  }

  handleOnChange (e) {
    const { value } = e.target
    this.props.onSelectFilter(value)
  }
}

ActivityFilter.propTypes = {
  selectedFilter: PropTypes.string,
  onSelectFilter: PropTypes.func.isRequired
}

ActivityFilter.displayName = 'ActivityFilter'

export default ActivityFilter



// WEBPACK FOOTER //
// ./components/ActivityFilter.js